import { render, staticRenderFns } from "./ppjslink.vue?vue&type=template&id=6e2a622f"
import script from "./ppjslink.vue?vue&type=script&lang=js"
export * from "./ppjslink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports